
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/sdks/csharp",
      function () {
        return require("private-next-pages/events/sdks/csharp.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/sdks/csharp"])
      });
    }
  